import React from "react";
import "./LoadingSpinner.css";

const LoadingSpinner = ({ message = "Loading, please wait..." }) => {
  return (
    <div className="spinner-container">
      <div className="spinner"></div>
      <p className="loading-message">{message}</p>
    </div>
  );
};

export default LoadingSpinner;
